/* file description */
// TODO refactor with ImportButton

import React, { FC, useEffect, useState } from 'react';
import { Modal, Upload, Spin, message, Collapse, Table } from 'antd';
import { DownloadOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { UploadFileProps } from './type';
import { AddOutline } from 'antd-mobile-icons';
import { getImportTemplate } from '@/api/page.api';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload';
import './index.less';

const { Panel } = Collapse;
const XLSX = 'xlsx';
interface LineError {
  row: string;
  // 中文列名
  column: string;
  message: string;
}

interface UploadFileResponse {
  code: number;
  data: {
    count: number;
    detail?: LineError[];
  };
  message: string;
}

const errorMessage = (msg: string) => {
  message.error(msg, 5);
};

const errorColumns = [{
  title: '错误行',
  dataIndex: 'row',
  key: 'row',
}, {
  title: '错误原因',
  dataIndex: 'message',
  key: 'message',
}];

export const TableImport: FC<UploadFileProps> = ({ uploadWrapVisible, reload, setUploadWrap, isMobile, taskId, pageType }) => {
  const [importSuccess, setImportSuccess] = useState(true);
  const [fileList, setFileList] = useState<Array<UploadFile<UploadFileResponse>>>([]);
  const [showErrorDetail, setShowErrorDetail] = useState(false);
  const [total, setTotal] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [errorSourceData, setErrorSourceData] = useState<Array<{ key: string; row: string; message: string }>>([]);

  useEffect(() => {
    if (!uploadWrapVisible) {
      setFileList([]);
    }
  }, [uploadWrapVisible]);

  const transferDetail = (detail: LineError[]) => {
    return detail.map((line, i) => {
      return {
        key: `${i}`,
        row: line.row,
        message: `${line.column}：${line.message}`,
      };
    });
  };

  const uploadChange = (info: UploadChangeParam<UploadFile<UploadFileResponse>>) => {
    const { file, fileList: files } = info;
    setFileList([...files]);

    if (file.status === 'uploading') {
      setImportSuccess(true);
      return;
    }

    // 业务错误
    if (file.status === 'done') {
      const { response } = file;
      if (!response) {
        errorMessage('导入失败，请重试');
        return;
      }

      const { code, data, message: msg } = response;
      if (code === undefined) {
        errorMessage('导入失败，请重试');
      } else if (code !== undefined && code !== 0) {
        const { detail, count } = data;
        if (code === 1003) {
          errorMessage(`您上传${count}条数据，存在${detail?.length}条错误！`);
        } else {
          errorMessage(`${msg}`);
        }

        setImportSuccess(false);
        if (detail) {
          setShowErrorDetail(!!detail);
          setTotal(count);
          setErrorCount(detail.length);
          const sourceData = transferDetail(detail);
          setErrorSourceData(sourceData);
        }
      } else {
        message.success('导入成功');
        setUploadWrap(false);
        reload();
      }
    } else if (file.status === 'error') {
      // http错误、网络错误
      setImportSuccess(false);
      setShowErrorDetail(false);
      if (file.error.status === 404) {
        errorMessage('导入失败，请导入模版文件！');
      } else {
        errorMessage('导入失败，请联系管理员！');
      }
    }
  };
  const clear = () => {
    setImportSuccess(true);
    setShowErrorDetail(false);
  };

  const closeModal = () => {
    setUploadWrap(false);
    clear();
  };

  const beforeUpload = (file: File) => {
    const suffix = file.name.split('.').pop();
    if (suffix?.toLowerCase() !== XLSX) {
      message.error('您上传的模板格式错误，请上传.xlsx格式文件！');
      setImportSuccess(false);
      setShowErrorDetail(false);
      return false;
    }
    return true;
  };

  const downloadTemplate = async () => {
    if (!taskId || !pageType) {
      console.error(`taskId and pageType can not be null,taskId:${taskId}, pageType:${pageType}`);
      return;
    }
    const res = await getImportTemplate(taskId, pageType);
    // 解析header获取文件名
    const contentDisposition = res.headers.get('Content-Disposition');
    if (!contentDisposition) {
      console.error('Header content-disposition not exist');
      return;
    }

    const splitContent = contentDisposition.split('\'\'');
    const filename = decodeURIComponent(splitContent[1]);

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };

  const getUploadUrl = (file: File) => {
    const name = file.name.split('.')[0];
    return `/api/gateway/metabase/excel/v1/tpl_import/${name}`;
  };

  const getMarginTop = () => {
    if (fileList.length === 0) {
      return '20px';
    }
    if (showErrorDetail) {
      return '10px';
    }
    return '30px';
  };

  if (!uploadWrapVisible) { return null; }
  return (
    <>
      <Modal
        title="导入"
        width="600px"
        open={uploadWrapVisible}
        footer={null}
        onCancel={closeModal}
        maskClosable={false}
      >
        <div style={{ paddingBottom: '15px' }} className={importSuccess ? '' : 'lcp-import-error'}>
          <a
            key="download"
            style={{ fontSize: '14px' }}
            onClick={downloadTemplate}
          >
            <DownloadOutlined /> 下载模板
          </a>
          <div style={{ height: '150px', marginTop: '20px' }}>
            <Upload.Dragger
              style={{ backgroundColor: '#fff' }}
              maxCount={1}
              showUploadList={{ showRemoveIcon: true }}
              fileList={fileList}
              action={getUploadUrl}
              onChange={uploadChange}
              beforeUpload={beforeUpload}
            >
              <div style={{ height: '40px', background: 'rgba(1,100,200,0.1)', margin: '0 140px', lineHeight: '40px', color: '#0164C8', fontSize: '14px' }}>
                {!isMobile ? <div> <CloudUploadOutlined /> 选择或拖拽上传文件</div> : <AddOutline fontSize={38} />}
              </div>
            </Upload.Dragger>
          </div>
          {showErrorDetail &&
            <div className="lcp-import-error-detail">
              <p>错误提示：本次导入{total}条数据，存在<span className="lcp-import-error-count">{errorCount}条</span>错误，请核对后再上传！</p>
              <Collapse ghost>
                <Panel header="错误数据详情" key="1">
                  <Table
                    dataSource={errorSourceData}
                    columns={errorColumns}
                    pagination={false}
                    size="small"
                  />
                </Panel>
              </Collapse>
            </div>
          }
          <p style={{ marginTop: getMarginTop() }}>· 上传文件大小不超过10M</p>
          <p>· 一次上传不能超过5000行、200列</p>
        </div>
      </Modal>
    </>
  );
};
